import Highlights from './List'
import Highlight from './Highlight'

export { Highlight }

export default Highlights
